<main
  [@.disabled]="!useAnimation"
  [ngClass]="{ 'prefers-reduced-motion': !useAnimation }">
  <div
    class="stack"
    [ngClass]="{
      'prek2-parent-container': activityService.isPreK2ReadingActivity()
    }">
    @if ((activityService.showHeader | async) ?? false) {
      <htc-header
        data-testid="htc-header"
        [exitButtonText]="exitButtonText | translate"
        [exitButtonIcon]="exitButtonIcon"
        [showExitButton]="(activityService.showExitButton | async) ?? false"
        [showRewards]="
          (activityService.showRewards | async) ?? false
        "></htc-header>
    }
    <div
      #htcPageContentContainer
      data-testid="htc-main-content-container"
      class="content-container reset-scrollbar {{
        activityService.activityState === ActivityStateEnum.QUESTION ||
        activityService.activityState === ActivityStateEnum.VIDEO
          ? pageTransitionService.pageTransition +
            ' ' +
            'content-container-with-bg'
          : pageTransitionService.pageTransition + ' '
      }}"
      [ngClass]="{
        'hide-scrollbar': scrollbarService.isScrollbarHidden$ | async
      }">
      @if ((activityService.showSecondaryHeader | async) ?? false) {
        <div class="content-absolute-bg"></div>
      }
      @if ((activityService.showSecondaryHeader | async) ?? false) {
        <htc-subheader
          data-testid="htc-subheader"
          [episode]="(activityService.episodeNumber | async) ?? '0'"
          [showProgressBar]="(activityService.showProgressBar | async) ?? false"
          [showElapsedTime]="
            featureFlagService.isFlagEnabled(
              FeatureFlags.FORCE_DISPLAY_ELAPSED_TIMER
            )
          "
          [progressBarEnabled]="progressBarEnabled"
          (clickedEvent)="onProgressNodeClick($event)"></htc-subheader>
      }
      <div class="content-main-router">
        <router-outlet></router-outlet>
      </div>
    </div>
    @if (footerService.show) {
      <htc-tools></htc-tools>
    }
    @if (footerService.show) {
      <htc-footer></htc-footer>
    }
    @if (
      expandedContentOpened &&
      featureFlagService.isFlagEnabled(FeatureFlags.EXPANDABLE_CONTENT)
    ) {
      <htc-expandable-modal
        [expandableContent]="
          (expandedContentService.getExpandedContent() | async) ??
          expandedContentService.defaultState
        "></htc-expandable-modal>
    }
  </div>
  <htc-message-popup></htc-message-popup>
  <htc-debug-menu></htc-debug-menu>
  @if (!platformSupported) {
    <htc-feedback
      id="feedbackPlatformSupport"
      [showAlert]="!platformSupported"
      alertClasses="feedback incorrect platform-warning"
      alertHeaderText="Warning!"
      feedbackText="This platform is not currently supported. You can still complete lessons, but some functionality may be missing."
      [showDiamond]="false"
      alertType="default"
      [incorrectAttempts]="0"
      data-testid="htc-platform-not-supported-feedback"></htc-feedback>
  }
  @if (loadingScreenService.loadingScreenState() > 0) {
    <htc-loading></htc-loading>
  }
</main>
